"use strict";
exports.__esModule = true;
exports.authorizationConfigSchema = void 0;
var validate_1 = require("./utils/validate");
var defaultRoleSchema = validate_1.objectProperties({
    read: validate_1.boolean,
    insert: validate_1.boolean,
    update: validate_1.boolean,
    remove: validate_1.boolean
});
var dataOwnerSchema = validate_1.objectProperties({
    read: validate_1.boolean,
    update: validate_1.boolean,
    remove: validate_1.boolean
});
exports.authorizationConfigSchema = {
    siteOwner: defaultRoleSchema,
    siteMember: defaultRoleSchema,
    dataOwner: dataOwnerSchema,
    anonymous: defaultRoleSchema
};
//# sourceMappingURL=authorizationConfigSchema.js.map